<div class="ds-page">
	<div class="ds-header">
		<h1 class="ds-header__title">Component Library</h1>
		<p class="ds-header__description">Explore our comprehensive design system components with various states, variants, and use cases.</p>
	</div>

	<eif-custom-tabs
		[tabs]="tabs"
		[activeTabId]="activeTabId"
		(tabChange)="onTabSelect($event)">
		<div class="ds-tab-panel">
			@switch (activeTabId) {
				@case ('resources-manager') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Resources Manager</h2>
							<p class="ds-section__description">Upload, edit, and download your resource translations</p>
						</div>
						<app-resources-manager-showcase></app-resources-manager-showcase>
					</div>
				}
				@case ('faq-manager') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> FAQ Manager</h2>
							<p class="ds-section__description">Manage FAQ categories and questions with multi-language support</p>
						</div>
						<app-faq-manager-showcase></app-faq-manager-showcase>
					</div>
				}
				@case ('faq-viewer') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> FAQ Viewer</h2>
							<p class="ds-section__description">View FAQs grouped by product and profile with accordion interface</p>
						</div>
						<app-faq-showcase></app-faq-showcase>
					</div>
				}
				@case ('form-showcase') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Form Components Showcase</h2>
							<p class="ds-section__description">All form components in two layout variants: all in one row, and one per row</p>
						</div>
						<app-form-components-showcase></app-form-components-showcase>
					</div>
				}
				@case ('form-example') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Form Components Example</h2>
							<p class="ds-section__description">
								Complex form showcasing all components: input, slider, radio, checkbox, select, switch, date picker with validation
							</p>
						</div>
						<app-form-components-example></app-form-components-example>
					</div>
				}
				@case ('toaster') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Toaster Component</h2>
							<p class="ds-section__description">
								Modern toast notifications with automatic/manual closing, actions, and multiple message support
							</p>
						</div>
						<app-toaster-showcase></app-toaster-showcase>
					</div>
				}
				@case ('buttons') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Button Components</h2>
							<p class="ds-section__description">Standard and icon button variations with different colors and states</p>
						</div>
						<app-buttons></app-buttons>
					</div>
				}
				@case ('icon-buttons') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Icon Button Components</h2>
							<p class="ds-section__description">Icon-only buttons with multiple variants</p>
						</div>
						<app-icon-buttons></app-icon-buttons>
					</div>
				}
				@case ('menus') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Menu Components</h2>
							<p class="ds-section__description">Dropdown menus with various configurations</p>
						</div>
						<app-menus></app-menus>
					</div>
				}
				@case ('checkboxes') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Checkbox Components</h2>
							<p class="ds-section__description">Checkbox inputs with different colors and states</p>
						</div>
						<app-checkboxes></app-checkboxes>
					</div>
				}
				@case ('radios') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Radio Components</h2>
							<p class="ds-section__description">Radio button inputs with different colors and states</p>
						</div>
						<app-radios></app-radios>
					</div>
				}
				@case ('switches') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Switch Components</h2>
							<p class="ds-section__description">Toggle switches with checkedValue/uncheckedValue, colors, and form integration</p>
						</div>
						<app-switches></app-switches>
					</div>
				}
				@case ('selects') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Select Components</h2>
							<p class="ds-section__description">Single and multiple select dropdowns with validation</p>
						</div>
						<app-selects></app-selects>
					</div>
				}
				@case ('inputs') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Input Components</h2>
							<p class="ds-section__description">Text inputs with various types and validation states</p>
						</div>
						<app-inputs></app-inputs>
					</div>
				}
				@case ('inputs-validation') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Input Validation Rules</h2>
							<p class="ds-section__description">Advanced input validation with custom rules</p>
						</div>
						<app-inputs-validation></app-inputs-validation>
					</div>
				}
				@case ('readonly') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Readonly Components</h2>
							<p class="ds-section__description">Readonly vs editable component comparison</p>
						</div>
						<app-readonly></app-readonly>
					</div>
				}
				@case ('slider') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Slider Components</h2>
							<p class="ds-section__description">Range slider with input, blocked range, validation, and various states</p>
						</div>
						<app-slider-showcase></app-slider-showcase>
					</div>
				}
				@case ('date-pickers') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Date Picker Components</h2>
							<p class="ds-section__description">Single date, date range, and time selection components</p>
						</div>
						<app-date-pickers></app-date-pickers>
					</div>
				}
				@case ('custom-tooltip') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Tooltip Component</h2>
							<p class="ds-section__description">Tooltip with flexible content, multiple triggers, and smart positioning</p>
						</div>
						<app-custom-tooltip-showcase></app-custom-tooltip-showcase>
					</div>
				}
				@case ('modals') {
					<div class="ds-section mt-4">
						<div class="ds-section__header">
							<h2 class="ds-section__title"><i class="fa-solid fa-arrow-right fa-xs"></i> Custom Modal System</h2>
							<p class="ds-section__description">
								A comprehensive modal system with various configurations, async actions, and accessibility features
							</p>
						</div>
						<app-modals-showcase></app-modals-showcase>
					</div>
				}
			}
		</div>
	</eif-custom-tabs>
</div>
